import moment from "moment";

export const bookingMinDate = (dt) => {
  const meta = document.querySelector('meta[name="lt"]');
  const date = new Date();
  const m = moment(dt ? dt : date)
    .add(meta ? parseInt(meta.getAttribute('content')) / 60 : 20, 'hours');
  return m.format('YYYY-MM-DD')
}
